import { Action, Mutation } from 'vuex-module-decorators';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { SurveySessionValueModel } from '@trialcard/apigateway.models';
import { Resolve } from 'vue-di';
import { Settings } from '~/services/settings';

export interface IEligibilityData {
    eligibilityFederal?: string;
    diagnosis?: string;
    doesAgreeMarketing?: string;

}
@InjectModule({ stateFactory: true }, module)
export default class EligibilityModule extends InjectVuexModule {
    @Resolve
    public settings!: Settings;

    public eligibilityData: SurveySessionValueModel[] = [];

    public isEligible = false;

    @Mutation
    public async updateEligibilityData(newEligibilityData: typeof EligibilityModule.prototype.eligibilityData) {
        this.eligibilityData = newEligibilityData;
    }

    @Mutation
    public async updateIsEligible(isEligible: boolean) {
        this.isEligible = isEligible;
    }

    @Action({ rawError: true })
    public checkPatientEligibility(eligibilityData: SurveySessionValueModel[]): boolean {
        if(localStorage.getItem('enrollmentTypePatientOrHCP')==='HCP'){
            // if(localStorage.getItem('drugNamePath')==='jevtana'){
            //     const correctAnswers = [
            //         +this.settings.hasBeenPrescribedAnswerYesIdHcpJevtana,
            //         +this.settings.isCommerciallyInsuredAnswerYesIdHcp,
            //         +this.settings.isFederalAnswerYesIdHcpJevtana,
            //         +this.settings.isUSResidentAnswerYesIdHcp,
            //         +this.settings.isAbove18YearsOfAgeAnswerYesIdHcp,
            //         +this.settings.iConsentAnswerYesId,
            //     ] as number[];
            //     const isEligible = eligibilityData.every(question => question.answerId && correctAnswers.includes(question.answerId));
            //     this.updateIsEligible(isEligible);
            //     return isEligible;
            // }
           //  if(localStorage.getItem('drugNamePath')==='sarclisa'){
                const correctAnswers = [
                    +this.settings.hasBeenPrescribedAnswerYesIdHcpSarclisa,
                    +this.settings.isCommerciallyInsuredAnswerYesIdHcp,
                    +this.settings.isFederalAnswerYesIdHcpSarclisa,
                    +this.settings.isUSResidentAnswerYesIdHcp,
                    +this.settings.isAbove18YearsOfAgeAnswerYesIdHcp,
                    +this.settings.iConsentAnswerYesId,
                ] as number[];
                const isEligible = eligibilityData.every(question => question.answerId && correctAnswers.includes(question.answerId));
                this.updateIsEligible(isEligible);
                return isEligible;
          //  }
            // else{
            //     const correctAnswers = [
            //         +this.settings.hasBeenPrescribedAnswerYesIdHcpElitek,
            //         +this.settings.isCommerciallyInsuredAnswerYesIdHcp,
            //         +this.settings.isFederalAnswerYesIdHcpElitek,
            //         +this.settings.isUSResidentAnswerYesIdHcp,
            //         +this.settings.iConsentAnswerYesId,
            //     ] as number[];
            //     const isEligible = eligibilityData.every(question => question.answerId && correctAnswers.includes(question.answerId));
            //     this.updateIsEligible(isEligible);
            //     return isEligible;
            // }
        }
        else{
            // if(localStorage.getItem('drugNamePath')==='jevtana'){
            //     const correctAnswers = [
            //         +this.settings.hasBeenPrescribedAnswerYesIdPatientJevtana,
            //         +this.settings.isCommerciallyInsuredAnswerYesIdPatient,
            //         +this.settings.isFederalAnswerNoIdPatient,
            //         +this.settings.isUSResidentAnswerYesIdPatient,
            //         +this.settings.isAbove18YearsOfAgeAnswerYesIdPatient,
            //         +this.settings.iConsentAnswerYesId,
            //     ] as number[];
            //     const isEligible = eligibilityData.every(question => question.answerId && correctAnswers.includes(question.answerId));
            //     this.updateIsEligible(isEligible);
            //     return isEligible;
            // }
           //  if(localStorage.getItem('drugNamePath')==='sarclisa'){
                const correctAnswers = [
                    +this.settings.hasBeenPrescribedAnswerYesIdPatientSarclisa,
                    +this.settings.isCommerciallyInsuredAnswerYesIdPatient,
                    +this.settings.isFederalAnswerNoIdPatient,
                    +this.settings.isUSResidentAnswerYesIdPatient,
                    +this.settings.isAbove18YearsOfAgeAnswerYesIdPatient,
                    +this.settings.iConsentAnswerYesId,
                ] as number[];
                const isEligible = eligibilityData.every(question => question.answerId && correctAnswers.includes(question.answerId));
                this.updateIsEligible(isEligible);
                return isEligible;
            //}
            // else{
            //     const correctAnswers = [
            //         +this.settings.hasBeenPrescribedAnswerYesIdPatientElitek,
            //         +this.settings.isCommerciallyInsuredAnswerYesIdPatient,
            //         +this.settings.isFederalAnswerNoIdPatient,
            //         +this.settings.isUSResidentAnswerYesIdPatient,
            //         +this.settings.isAbove18YearsOfAgeAnswerYesIdPatient,
            //         +this.settings.iConsentAnswerYesId,
            //     ] as number[];
            //     const isEligible = eligibilityData.every(question => question.answerId && correctAnswers.includes(question.answerId));
            //     this.updateIsEligible(isEligible);
            //     return isEligible;
            // }
        }
    }
}
